<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">แบบฟอร์มที่ยื่นเสนอ สป.อว</div>
        <div class="d-flex align-center">
          <Iconify
            icon="bxs:message-square-detail"
            color="var(--theme-color-seven)"
            class="mr-3"
          ></Iconify>
          <div class="">แบบฟอร์มที่ยื่นเสนอ สป.อว</div>
        </div>
      </div>
      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center gap-8" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
              placeholder="สถานะ"
              hide-details
              clearable
              :items="statusMaster"
                     item-text="label"
            item-value="value"
              @onChange="
                searchData.status = $event;
                getLists();
              "
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
              @onChange="searchData.keyword = $event"
              @onEnter="getLists()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-space-between mb-5  px-8" >
    <div
        v-for="(item, i) in headers"
        :key="i"
        :style="{ width: item.width }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="list-layout">
      <div v-for="(item, i) in evaluateLists" :key="i">
  <RowCard>
    <div :style="{ color: getColorVariable(), width: headers[0].width }">
      {{ item?.No }}
    </div>
    <div :style="{ width: headers[1].width }">
      {{ item?.fiscal_year }}
    </div>
    <div :style="{ width: headers[2].width }">
        อุทยานวิทยาศาสตร์
    </div>
    <div :style="{ width: headers[3].width }">
      {{ item?.region }}
    </div>
    <div :style="{ width: headers[4].width }">
      ครั้งที่ {{ item?.running_number }}
    </div>
    <div  :style="{ width: headers[5].width , color :getColorStatus(item?.status) }">
       {{ item?.status }}
    </div>
    <div class="d-flex align-center justify-center " :style="{ width: headers[4].width }">
      <Button v-if="item?.status === 'Draft'"
        @onClick="consider(item)"
        :disabled="!checkStatus(item)"
        :theme="checkStatus(item) ? 1 : 2"
        minWidth="108px"
      >
          <Iconify
            icon="material-symbols-light:mail-rounded"
            size="18px"
            class="mr-2"
            color="#ffffff"
          ></Iconify>
        <span >ส่งผลพิจารณา</span>
      </Button>
    </div>
    <v-btn
      icon
      :class="{ rotate180: isExpanded[i] }"
      @click="() => seeDetail(i)"
    >
      <Iconify
        icon="material-symbols:keyboard-arrow-down"
        size="32px"
        :color="getColorVariable()"
      ></Iconify>
    </v-btn>
  </RowCard>
  <div class="expand-layout px-5" :class="`expand-${i}`">
    <div class="expand-content d-flex flex-column gap-12">
     
      <div class="d-flex text-left items-center  justify-space-between table-head">
              <div
                v-for="(item, i) in subHeaders"
                :key="i"
                :style="{ width: item.width, color: '#B1B1B1'}"
              >
                {{ item.name }}
              </div>
            </div>
            <div  v-if='item?.area_forms.length > 0'>
              <div
                v-for="(area, i) in item?.area_forms" 
                :key="area.id || i" 
                class="d-flex px-9 gap-8  text-left items-center  justify-space-between"
                style='padding-top: 11px'>
              <div  div :style="{ width: subHeaders[0]?.width}">
                  <v-btn  v-if="area?.spider_form !== null &&  item?.status !== 'Draft'"
                    small
                    icon
                    class="edit-icon-class"
                    @click="onView(area?.spider_form?.id)"
                  >
                    <Iconify icon="material-symbols:visibility" color="black" size="18px"></Iconify>
                   
                  </v-btn>
                  <v-btn  v-if="area?.spider_form !== null  &&  item?.status === 'Draft'"
                    small
                    icon
                    class="edit-icon-class"
                    @click="onEdit(area?.spider_form?.id)"
                  >
                  <Iconify  icon="material-symbols:edit" 
                    color="var(--theme-color-seven)"
                    size="18px"></Iconify>
                  </v-btn>
                </div>
                <div :style="{ width: subHeaders[1].width }">
                  {{ area?.area_form_2?.company_name_th }}
                </div>
                <div :style="{ width: subHeaders[2].width }">
                  {{ dateFormatting(area?.approved_at) }}
                </div>
                <div :style="{ width: subHeaders[3].width }">
                  <v-tooltip  v-if="area?.status === 'Approved'"
                  top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span text v-bind="attrs" v-on="on">
                        <Iconify   icon="material-symbols:check-rounded" color="green" size="22px"></Iconify> 
                      </span>
                    </template>
                    <span>ผ่านเกณฑ์พิจารณา</span>
                  </v-tooltip>
                  <v-tooltip v-else-if='area?.status === "Rejected" || area?.status === "In Review"'
                  top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span text v-bind="attrs" v-on="on">
                      <Iconify  icon="material-symbols:close-rounded" color="red" size="22px"></Iconify>
                      </span>
                    </template>
                    <span>
                      {{  area?.status === "Rejected" ? 'ไม่ผ่านเกณฑ์พิจารณา' : 'อยู่ระหว่างพิจารณา'}}
                    </span>
                  </v-tooltip>
                </div>
                <div 
                  :class="{ 'hover-pointer underline-text': area?.evaluate_forms?.length > 0 }" 
                  @click="area?.evaluate_forms?.length > 0 && routeToConsider(area?.evaluate_forms[0]?.area_form_id)" 
                  :style="{ width: subHeaders[4].width }"
                >
                  {{ area?.evaluate_forms?.length ?? 0 }}/5
                </div>
                <div :style="{ width: subHeaders[5].width ,color: getColorStatus(area?.status)  }">
                  <span :style="{ color: getColorStatus(area?.spider_form?.status)  }"  v-if='area?.spider_form !== null'>{{ area?.spider_form?.status }}
                  </span>
                  <span v-else> 
                    <Button
                      @onClick="routeToChart(area?.id ,area?.evaluate_forms.length)"
                      minWidth="100px"
                      :theme='area?.evaluate_forms.length >= 1 ? "3" : "2"'
                      :disabled='area?.evaluate_forms.length >= 1 ? false : true'
                      style='translate: 0px -10px'
                    >
                      <span >สร้าง Spider Chart</span>
                    </Button>
                  </span>
                </div>
                
              </div>
            </div>
              <div v-else class='flex text-center'>
                ไม่มีข้อมูล
              </div>
    </div>
  </div>
</div>

  </div>
  <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getLists"
    ></v-pagination>
  </div>
</template>

<script>
import RowCard from "@/components/RowCard";
import SelectBox from "@/components/input/SelectBox";
import TextField from "@/components/input/TextField";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import Button from "@/components/input/Button";
import { color } from "highcharts";

export default {
  name: "spaceRequestsOffer",
  components: {
    RowCard,
    SelectBox,
    TextField,
    Button
  },
  data() {
    return {
      toDateFormat,
      formatNumber,
      redText: false,
      isExpanded: [],
      statusMaster: [{label:"แบบร่าง",
        value:"Draft"}
      , {label:"รอพิจารณา",
      value:"In Review"}, {label:"รออนุมัติ",
      value:"Submitted"}, {label:"อนุมัติ/เสร็จสิ้น",
      value:"Approved"}],
      searchData: {
        status: null,
        keyword: null,
      },
      headers: [
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "ปี งปม.",
          width: "8%",
        },
        {
          name: "ชื่อโครงการหลัก",
          width: "34%",
        },
        {
          name: "ภูมิภาค",
          width: "12%",
        },
        {
          name: "ครั้งที่",
          width: "12%",
        },
        {
          name: "สถานะ",
          width: "12%",
        },
        {
          name: "",
          width: "14%",
        },
        {
          name: "",
          width: "2%",
        },
      ],
      subHeaders: [
        {
          name: "Action",
          width: "6%",
        },

        {
          name: "บริษัท",
          width: "35%",
        },
        {
          name: "วันที่อนุมัติ",
          width: "20%",
        },
        {
          name: "เกณฑ์พิจารณา",
          width: "12%",
        },
        {
          name: "ผู้เชี่ยวชาญ",
          width: "9%",
        },
        {
          name: "สถานะ",
          width: "18%",
        },
      ],
      evaluateLists: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      
    };
  },
  created() {

    this.getLists();
  },
  methods: {
    seeDetail(index) {
      let growDiv = document.querySelector(`.expand-${index}`);
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.$set(this.isExpanded, index, false);
      } else {
        let wrapper = growDiv.querySelector(".expand-content");
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.$set(this.isExpanded, index, true);
      }
    },
    getColorVariable() {
      return 'var(--theme-color-one)';
    },
    getColorStatus(status) {
      if(status == 'Submitted' ){
        return 'var(--theme-color-five)';
      }else if(status == 'Draft' ) {
        return 'var(--theme-color-seven)';
      }else if(status == 'Not Approved' ) {
        return 'var(--theme-color-four)';
      }else if(status == 'Approved' ) {
        return 'var(--theme-color-three)';
      }else if(status == 'In Review' ) {
        return 'var(--theme-color-one)';
      }
    },
    getStatusName(status) {
      if(status == 'Submitted' ){
        return 'บันทึกคะแนนแล้ว';
      }else if(status == 'Draft' ) {
        return 'บันทึกฉบับร่าง';
      }
    },
    checkStatus(data) {
      if (data?.area_forms.length === 0) return false
      // console.log('checkStatus data: ', data);
      const status = data?.area_forms.every(
        (item) => item?.spider_form?.status === 'Submitted'
      );
      return status
    },
    async getLists(page) {
      let payload = {
        page: page,
        status: this.searchData.status ?? "Draft,In Review,Submitted,Approved",
        keyword: this.searchData.keyword,
      };
      let res = await this.$apiFire("Request/getEvaluateAreaList",payload);
      if (res) {
      console.log("res: ",res);
        this.evaluateLists = res?.data.map((item, index) => {
          return {
            ...item,
            No: (res.current_page - 1) * res.per_page + index + 1,
          };
        });
        this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
      }
    },
    async consider(data) {
      const status = this.checkStatus(data)
      console.log('data.id',data.id);
      
      if (status === false) return
      else{
        let res = await this.$apiFire("Request/sendToConsiderApprove",data.id);
      if (res) {
        this.getLists();
      }
      }
    },
    routeToChart(id , evaluateCount) {
      if (evaluateCount < 1) return
      this.$router.push({ name: "spiderChartForm", query: { 
        areaID: id,
       } });
    },
    onEdit(id) {
      if (id){
        this.$router.push({ name: "spiderChartFormEdit", params: { 
        id: id,
      } });
      }
    },
    onView(id) {
      if (id){
        this.$router.push({ name: "spiderChartPreview", params: { 
          id: id,
        }, query: { 
        preview: true,
       } });
      }
    },
    routeToConsider(id){
        this.$router.push({
          name: "ConsiderResultAF",
          params: { area_form_id: id,
          },
        });
    },
    dateFormatting(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);

      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      const thaiLocaleDate = new Intl.DateTimeFormat("th-TH", options).format(
        date
      );

      const thaiMonthAbbreviations = {
        มกราคม: "ม.ค.",
        กุมภาพันธ์: "ก.พ.",
        มีนาคม: "มี.ค.",
        เมษายน: "เม.ย.",
        พฤษภาคม: "พ.ค.",
        มิถุนายน: "มิ.ย.",
        กรกฎาคม: "ก.ค.",
        สิงหาคม: "ส.ค.",
        กันยายน: "ก.ย.",
        ตุลาคม: "ต.ค.",
        พฤศจิกายน: "พ.ย.",
        ธันวาคม: "ธ.ค.",
      };
      const [day, month, yearTime] = thaiLocaleDate.split(" ");

      const abbreviatedMonth = thaiMonthAbbreviations[month] || month;

      const year = parseInt(yearTime, 10);

      const time = thaiLocaleDate.split(" ")[4];
      const hour = time.split(":")[0];
      const minute = time.split(":")[1];

      return `${day} ${abbreviatedMonth} ${year} เวลา ${hour}:${minute} น.`;
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 8px 33px 8px 36px;
  margin-bottom: 12px;
  border-bottom: solid 1px var(--theme-color-nine);
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.edit-icon-class{
  translate: 0 -5px;
}
.hover-pointer:hover{
  cursor: pointer;
}
.underline-text{
  text-decoration: underline;
}
</style>
